<template>
  <div class="m-product-add-to-cart">
    <SfAddToCart
      v-model="qty"
    >
      <template #quantity-select-input>
        <AProductQuantity
          class="sf-add-to-cart__select-quantity"
          v-if="product.type_id !== 'grouped' && product.type_id !== 'bundle' && !showQuantityCalculator"
          v-model="qty"
          :max-quantity="Math.max(stock.max, stock.maxPickup)"
          :loading="stock.isLoading"
          :unlimit-quantity="!isSimpleOrConfigurable"
          @input="$emit('input', $event)"
          @error="handleQuantityValidationError"
          :product="product"
        />
        <AProductQuantityCalculator
          class="sf-add-to-cart__select-quantity"
          v-if="product.type_id !== 'grouped' && product.type_id !== 'bundle' && showQuantityCalculator"
          v-model="qty"
          :max-quantity="Math.max(stock.max, stock.maxPickup)"
          :loading="stock.isLoading"
          :unlimit-quantity="!isSimpleOrConfigurable"
          @input="$emit('input', $event)"
          @error="handleQuantityValidationError"
          :product="product"
        />
        <!--<span v-else>&nbsp;</span>-->
      </template>

      <template #add-to-cart-btn>
        <div class="sf-add-to-cart__buttons">
          <div class="add-to-cart__online">
            <AAddToCart
              class="btn btn-primary sf-add-to-cart__button"
              :qty="qty"
              :product="product"
              :disabled="isAddToCartDisabled"
              label="Online bestellen"
            />

            <div class="product-addtocart-bottom">
              <OnlineAvailability
                :product="product"
                :qty="stock.max"
                :threshold-qty="stock.thresholdQuantity"
                :show-delivery-time="true"
              />
            </div>
          </div>

          <div class="add-to-cart__click-and-collect">
            <AAddToCart
              class="sf-button click-and-collect__button btn btn-secondary"
              :qty="qty"
              :product="product"
              :disabled="isPickupDisabled"
              :is-pickup-button="true"
              label="Abholen"
            />

            <div class="product-addtocart-bottom">
              <StoreAvailability
                :product="product"
                :qty="stock.max"
                :qty-pickup="stock.maxPickup"
                :threshold-qty="stock.thresholdQuantity"
                :show-modal-button="true"
                :show-not-selected="true"
              />
            </div>
          </div>
        </div>
      </template>
    </SfAddToCart>

    <!--<SfAlert
      v-if="alert"
      class="alert"
      :message="alert.message"
      :type="alert.type"
    />-->
    <MProductStockAlert
      v-if="stock.max === 0"
      :product="product"
    />

    <!--<AAddToWishlist
      :product="product"
    />-->
  </div>
</template>
<script>
import { onlineHelper } from '@vue-storefront/core/helpers';
import { SfAddToCart, SfAlert } from '@storefront-ui/vue';
import AProductQuantityCalculator from 'theme/components/atoms/a-product-quantity-calculator';
import AProductQuantity from 'theme/components/atoms/a-product-quantity';
import AAddToCart from 'theme/components/atoms/a-add-to-cart';
import StoreAvailability from 'src/modules/vsf-inventory-sources/components/StoreAvailability'
import AAddToWishlist from 'theme/components/atoms/a-add-to-wishlist';
import OnlineAvailability from 'src/modules/vsf-inventory-sources/components/OnlineAvailability';
import MProductStockAlert from 'theme/components/molecules/m-product-stock-alert';

export default {
  name: 'MProductAddToCart',
  components: {
    SfAddToCart,
    SfAlert,
    AProductQuantity,
    AProductQuantityCalculator,
    AAddToCart,
    StoreAvailability,
    AAddToWishlist,
    OnlineAvailability,
    MProductStockAlert
  },
  data () {
    return {
      qty: 1,
      qtyValidationError: '',
      baseQty: 0
    };
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    },
    stock: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.updateBaseQuantity(this.qty)
  },
  watch: {
    qty: function (qty) {
      this.updateBaseQuantity(qty)
    }
  },
  computed: {
    isOnline () {
      return onlineHelper.isOnline;
    },
    isAddToCartDisabled () {
      return !!this.qtyValidationError || this.stock.isLoading || !this.isAvailable || !this.stock.max
    },
    isPickupDisabled () {
      return !!this.qtyValidationError || this.stock.isLoading || !this.isAvailable || 
        (!this.stock.maxPickup && !this.stock.max) || this.stock.maxPickup === null
    },
    isAvailable () {
      return !this.isOnline || !!this.stock.max || !!this.stock.maxPickup || !this.stock.manageQuantity || !this.isSimpleOrConfigurable
    },
    isSimpleOrConfigurable () {
      return ['simple', 'configurable'].includes(
        this.product.type_id
      );
    },
    alert () {
      if (this.qtyValidationError) {
        return {
          type: 'danger',
          message: this.qtyValidationError
        }
      }
      if (!this.isAvailable) {
        return {
          type: 'danger',
          message: this.$t('Selected variant is out of stock')
        }
      }
      return false
    },
    showQuantityCalculator () {
      return this.product.baseprice_product_amount && this.product.baseprice_product_unit
    }
  },
  methods: {
    handleQuantityValidationError (error) {
      this.qtyValidationError = error
    },
    updateBaseQuantity (qty) {
      this.baseQty = (qty * this.product.baseprice_product_amount).toFixed(2)
    },
    updateQuantity (baseQty) {
      this.qty = Math.floor(baseQty / this.product.baseprice_product_amount)
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  margin-bottom: var(--spacer-base)
}
</style>
